exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-config-section-wrapper[data-v-b8981cf8]{padding:1.5rem;flex:1 1 auto;display:flex;flex-direction:column}", ""]);

// exports
